import { render, staticRenderFns } from "./Scenes.vue?vue&type=template&id=8aba7bc6&scoped=true&"
import script from "./Scenes.vue?vue&type=script&lang=js&"
export * from "./Scenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aba7bc6",
  null
  
)

export default component.exports